import type { Point } from '@/store/models/kop/utils'

/**
 * Converts two points into a rectangle's corner points.
 * @param startPoint - The fixed starting point [x1, y1].
 * @param endPoint - The dynamic end point [x2, y2].
 * @param height - The desired width of the rectangle.
 * @returns A flat array of the rectangle's four corners [topLeft, topRight, bottomRight, bottomLeft].
 */
export function pointsToRectangle(startPoint: Point, endPoint: Point, height: number): number[] {
  const halfHeight = height / 2
  const [x1, y1] = startPoint
  const [x2, y2] = endPoint

  const dx = x2 - x1
  const dy = y2 - y1
  const length = Math.sqrt(dx * dx + dy * dy)

  const offsetX = -dy / length * halfHeight
  const offsetY = dx / length * halfHeight

  const p1: Point = [x1 + offsetX, y1 + offsetY]
  const p2: Point = [x2 + offsetX, y2 + offsetY]
  const p3: Point = [x2 - offsetX, y2 - offsetY]
  const p4: Point = [x1 - offsetX, y1 - offsetY]

  return [...p1, ...p2, ...p3, ...p4]
}
